// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React, { ReactNode } from 'react';
import { Alignment, IStackItemStyles, Stack } from '@fluentui/react';
import { Header } from './Header';

export const Page = (props: {
  onHomeClick: () => void;
  callId?: string | undefined;
  children: ReactNode;
  horizontalFill?: boolean;
  verticalAlign?: Alignment;
}): JSX.Element => {
  return (
    <Stack verticalFill>
      <Stack.Item styles={headerStyles}>
        <Header callId={props.callId} onHomeClick={props.onHomeClick} />
      </Stack.Item>
      <Stack.Item grow>
        <Stack verticalFill horizontalAlign="center" verticalAlign={props.verticalAlign}>
          <Stack.Item
            grow={props.verticalAlign === 'center' ? undefined : 1}
            styles={props.horizontalFill ? spanWidthStyles : undefined}
          >
            {props.children}
          </Stack.Item>
        </Stack>
      </Stack.Item>
    </Stack>
  );
};

const headerStyles: IStackItemStyles = {
  root: {
    height: '3rem'
  }
};

const spanWidthStyles: IStackItemStyles = {
  root: {
    width: '100%'
  }
};
